<style lang="scss" scoped>
.modal-desc {
    padding: 20px 0;
    text-align: center;
    font-size: 13px;
}
.modal-button {
    float: right;
}
</style>
<template>
	<section class="margin-15">
		<template v-if="type==='query'">
			<span>
				{{$t('fbb.alloment.total_sku_total', { defaultValue: '总计：SKU种数合计：' })}}{{dataList.length}}&nbsp;&nbsp;
				{{$t('fbb.misc.inbound_total_qty', { defaultValue: '入库总数量：' })}}{{dataList|handleTotalDataList('qty')}}&nbsp;&nbsp;
			</span>
		</template>
		<template v-else>
			<vFormItem label-width="100"   inline label="ERP SKU:" class="margin-bottom-10">
				<vInput v-model="formData.erpSku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
			</vFormItem>
			<vFormItem label-width="100"   inline :label="$t('fbb.alloment.inbound_number', { defaultValue: '入库数量' }) + ':'">
				<vInputNumber clearable v-model="formData.miscInboundqty" :min="1"/>
			</vFormItem>
			<vFormItem label-width="100" inline :label="$t('global.common.notes', { defaultValue: '备注' }) + ':'">
				<vInput clearable v-model="formData.remark"/>
			</vFormItem>
			<vButton theme="primary" class="margin-left-10" @click="addItem(formData)">{{$t('fbb.alloment.add_by_one', { defaultValue: '逐个添加' })}}</vButton>
			<vButton theme="info" class="margin-left-10" @click="handleUploadData">{{$t('fbb.alloment.muti_import', { defaultValue: '批量导入' })}}</vButton>
			<aside>
				<!-- <vButton class="margin-right-10" theme="gray" @click="clearAll">{{$t('global.common.clear', { defaultValue: '清空所有' })}}</vButton> -->
				
					<vButton class="margin-right-10" theme="warning" @click="removeItems">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
					<vButton class="margin-right-10" theme="error" @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				{{$t('fbb.alloment.total_sku_total', { defaultValue: '总计：SKU种数合计：'})}}{{dataList.length}}&nbsp;&nbsp;
				{{$t('fbb.misc.inbound_total_qty', { defaultValue: '入库总数量：' })}}{{dataList|handleTotalDataList}}
			</aside>
		</template>
		<vTableSimple class="margin-top-10" :columns="columns" :data="dataList" @on-check-change="handleCheckData"></vTableSimple>
		<vModal
			v-model="modalProps.show"
			:title="modalProps.title"
			:width="modalProps.width||1000"
			:showFooter="false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</vModal>
	<compModal
            v-model="modalProps2.show"
            v-bind="modalProps2"
            @on-close="modalProps2.show = false"
            @on-confirm="modalProps2.show = false"
        >
              <div class="clearfix" v-if="modalProps2.showConfirm">
                <div class="modal-desc">{{ modalProps2.desc }}</div>
                <div class="modal-button">
                    <Button
                        class="margin-right-15"
                        type="primary"
                        @click="modalProps2.confirm"
                        >{{$t('global.common.confirm', { defaultValue: '确定' })}}</Button
                    >
                    <Button type="default" @click="modalProps2.show = false"
                        >{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</Button
                    >
                </div>
            </div>
            <component
                v-if="modalProps2.component"
                :is="modalProps2.component"
                v-bind="modalProps2.props"
                @on-close="modalProps2.show = false"
                @on-success="modalSuccess"
                v-on="modalProps2.on"
            />
        </compModal>
	</section>
</template>

<script>
import {  } from '@/service/misc';
import compErpsku from './erpsku'
export default {
	props: ['data', 'baseData','querytype'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compErpsku
	},
	data() {
		return {
			type: this.querytype || this.$route.params.type,
			name: this.$route.name,
			id:this.$route.query.id,
			formData: {
				
			},
			checkedData: [],
			dataList: this.data || [],
			modalProps: {
				show: false,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "",
				width: 1000,
				props: {},
				on: {},
			},
			modalProps2: {
				show: false,
				width: 600,
				props: {},
				on: {},
			}
		}
	},
	watch: {
		data(val) {
			this.dataList = val;
		},
	},
	computed: {

		columns() {
			return this.type !== 'query' ? [{
				type: 'selection',
				formName: 'sku',
				width: this.type === 'query' ? 0 : 60
			}, {
				title: "No.",
				type: 'index'
			}, {
				title: "ERP SKU",
				key: 'sku'
			}, {
				title: this.$t('fbb.alloment.inbound_number', { defaultValue: "入库数量" }),
				key: 'qty'
			}, {
				title: this.$t('global.common.notes', { defaultValue: "备注" }),
				key: "remark",
			}/* , {
				title: this.$t('global.common.operation', { defaultValue: '操作' }),
				align: 'center',
				render: (h, { index }) => {
					return <vButton theme="error" nativeOnClick={this.removeItem.bind(this, index)}>{this.$t('global.common.delete', { defaultValue: '删除' })}</vButton>
				}
			} */] :
				[{
					title: "ERP SKU",
					key: 'sku'
				}, {
					title: this.$t('fbb.alloment.inbound_number', { defaultValue: "入库数量" }),
					key: 'qty'
				}, {
					title: this.$t('global.common.notes', { defaultValue: "备注" }),
					key: "remark",
				},{
					title: this.$t('global.common.updatedAt	', { defaultValue: "更新时间" }),
					key: "createdAt",
				}]
		}
	},
	filters: {
		handleTotalDataList(data = [], type = "qty") {
			let total = 0;
			data.forEach(item => {
				total += item[type];
			});
			return total;
		},
	},
	methods: {
		handleSkuErp() {
			const { organizationId } = this.baseData;
			if (!organizationId ) return this.$VMessage.warning(this.$t('fbb.misc.fill_organization', { defaultValue: '请填写组织客户' }));
			this.modalProps = {
				show: true,
				title: this.$t('fbb.alloment.choose_product', { defaultValue: '选择产品' }),
				component: "compErpsku",
				props: {
					initFormData: {
						'contextId': organizationId,
					}
				},
				on: {
					'on-data': (row) => {
						this.formData = Object.assign(this.formData, row, { erpSku: row.sku });
						this.modalProps.show = false;
					}
				},
			}
		},
		/**
		 * 获取选中产品sku
		 */
		handleCheckData(rows, val) {
			this.checkedData = val;
		},
			//上传数据
		handleUploadData() {
			const { organizationId } = this.baseData;
			if (!organizationId) return this.$VMessage.warning(this.$t('fbb.misc.fill_organization',{ defaultValue: '请先填写客户组织' }));
			this.modalProps = {
				show: true,
				title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
				component: "compUpload",
				width: 520,
				props: {
					data: {'orgId': organizationId },
					action: process.env.VUE_APP_APIURL_FBB + "/api/v2/MiscInboundOrderItem/importOrderItem",
					name: "multipartFile",
					download: () => {
						this.handleWebfs("/static/template/MiscInboundOrderItem.xlsx", {}, {
							executor: 'download',
							type: 'url'
						});
					
					},
				},
				on: {
					'on-success': (row) => {
						row.data.forEach((item) => {
							console.log(item)
							this.addItem({ miscInboundqty: item.qty, sku: item.sku,remark:item.remark });
						})
						this.modalProps.show = false;
					}
				},
			}
		},
		removeItems() {
			const checkedData = this.checkedData;
			if (!checkedData.length) {
				this.$VMessage.warning(this.$t('fbb.alloment.choose_product', { defaultValue: '请选择产品' }));
				return
			}
			this.modalProps2 = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				showFooter:true,
				ajaxRequest: async () => {
					this.dataList = this.dataList.filter((row) => {
						return checkedData.indexOf(row.sku) == -1
                    })
                    //this.handleTotalDataList(this.dataList);
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}

        },
		addItem(data) {
			const { sku, miscInboundqty,remark } = data;
			if (/^[1-9]\d*$/.test(miscInboundqty) && Number(miscInboundqty) > 0) {
                             if (sku && miscInboundqty) {
				const erpSkuData = this.dataList.find((item) => {
					return item.sku === sku
				});
				if (erpSkuData) {
					erpSkuData.qty += miscInboundqty;
					// if (erpSkuData.qty > qty) erpSkuData.qty = qty;
				} else {
					this.dataList.push({ sku, qty: miscInboundqty,remark })
				}
				this.formData = { qty: '' };
				return;
			}
			this.$VMessage.warning(this.$t('fbb.misc.fill_erpsku_qty', { defaultValue: '请填写ERP SKU和入库数量' }));
			} else {
				this.$VMessage.warning(this.$t('fbb.accountmanage.enter_more_than_zero', { defaultValue: '请输入大于0的正整数' }));
			}
			
		},
		clearAll() {
				this.modalProps2={
                    show: true,//显示弹框
					showConfirm:true,
                    desc: this.$t('fbb.alloment.confirm_clear_all_data', { defaultValue: '是否确认清空所有数据？' }),
					title: this.$t('fbb.misc.clear', { defaultValue: '清空' }),//标题，
					showFooter:false,
					confirm: ()=>{
						this.dataList = [];
						this.modalProps2.show=false;
					}
                   
                };
			
		},
		removeItem(index) {
			this.dataList.splice(index, 1)
		},

	}
}
</script>